<!--
作者：小明哥
组件：视频推荐
框架：VUE、vue-router、vuex、axios、ElementUI等
脚手架：VUE CLI3
-->
<template>
    <div class="develop-video-content">
        <div v-if="fromPage==1" class="public-content-header">
            <div class="public-content-header-right flex">
                <slot></slot>
                <p class="gray-9"><a :href="moreUrl">查看更多课程>></a></p>
            </div>
        </div>

        <!--在首页显示时的模板-->
        <el-scrollbar style="height:312px;width: 1200px; margin: auto;" v-if="fromPage==1">
            <div class="develop-video-list" :style="{width: (305*list.length-20) +'px'}">
                <div class="list-item home-list-item-recommment" v-for="(item,index) in list" :key='index'>
                    <div class="item-img" @click="toCourseDetail(item.courseId)">
                        <img v-if="item.courseImg" :src="item.courseImg | imgUrl" alt="">
                        <div class="item-img-modal">
                            <img style="border-radius: 5px;" src="../assets/img/develop/develop-play.png"
                                 :alt="item.courseTypeName +'-'+item.courseName">
                        </div>
                        <p class="video-time">{{item.createTime | dateFormat}}</p>
                    </div>
                    <p class="item-name" style="color: #909399;">{{item.courseTypeName}} [{{item.courseCategoryName | courseCategoryNameDes }}]</p>
                    <p class="item-name">{{item.courseName}}</p>
                    <p class="item-study">
                        <span class="tag" v-for="(item,index) in comm.tags(item.tag)" :key="index">
                            {{item}}
                        </span>
                        <span v-if="item.studyNumber==0"></span>
                        <span v-else>{{item.studyNumber | number}}人学</span>
                    </p>
                </div>
            </div>
        </el-scrollbar>

        <!--在列表页面显示时的模板-->
        <div v-if="fromPage==2">
            <a href="#" @click="toCourseDetail(item.courseId)" class="list-group-item list-group-item-action py-3"
               v-for="(item,index) in list" :key='index'>
                <div class="media">
                    <span class="img rounded mr-3"
                          :style="{backgroundImage: 'url('+showImgUrl(item.courseImg)+')'}"></span>
                    <div class="media-body">
                        <span class="type">{{item.courseTypeName}} [{{item.courseCategoryName | courseCategoryNameDes }}]</span>
                        <span class="name">{{item.courseName}}</span>
                    </div>
                </div>
                <div class="media-text">
                    <ul>
                        <li class="tag" v-for="(item,index) in comm.tags(item.tag)" :key="index">{{item}}</li>
                    </ul>
                    <span>{{item.studyNumber | number}}人学</span>
                </div>
            </a>
        </div>

    </div>
</template>
<script>
    export default {
        name: "VideoRecommendComm",
        props: {
            fromPage: {
                type: Number,
                default: -1
            },
            //完整的URL
            fullUrl: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                list: [],
                total: 0,
                url: null,
                //TODO
                //带优化，需要设置参数，进入课程页面后，自动搜索到此类课程。
                moreUrl: "course"
            }
        },
        created: function () {
            this.init();
        },

        methods: {
            init() {
                this.getData();
            },

            //获取页面数据,支持直接传参数
            getData() {
                this.url = this.fullUrl;
                this.comm.getBaseListApi(this.url,rs => this.list =rs);
            },

            showImgUrl(value) {
                return this.config.baseImgUrl + value;
            },

            //详情页跳转
            toCourseDetail: function (vid) {
                window.open("/courseDetail/" + vid + "/0");
            }
        }
    }
</script>

<style scoped>
    .mini-video-list {
        width: 300px;
    }
    a:hover {
        background-color: #f6f6f6;
    }

    .list-group-item:first-child {
        border-top: 0;
    }

    .list-group-item:first-child {
        border-top-width: 0;
    }

    .sidebar :first-child {
        margin-top: 0;
    }

    .list-group-item {
        border-right-width: 0;
        border-left-width: 0;
        border-radius: 0;
    }

    .list-group-item:first-child {
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }

    .list-group-item, .list-group-item.active {
        border-color: rgba(0, 0, 0, .05);
    }

    .py-3 {
        padding-bottom: 1rem !important;
    }

    .py-3 {
        padding-top: 1rem !important;
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: .45rem;
        background-color: #fff;
        border-bottom: 1px solid #eeeeee;
    }

    .list-group-item:last-child {
        border-bottom: 0px;
        box-shadow: 0 2px 2px 0 rgba(204, 204, 204, 0.50);
        border-radius: .25rem;
    }

    .list-group-item-action {
        width: 100%;
        color: #495057;
        text-align: inherit;
    }

    .sidebar :first-child {
        margin-top: 0;
    }

    .media {
        display: flex;
        align-items: flex-start;
    }

    .list-group-item .img {
        width: 80px;
        height: 60px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position-x: center;
    }

    .mr-3{
        margin-right: 1rem !important;
    }

    .rounded {
        border-radius: .25rem !important;
    }

    .media-body {
        flex: 1;
    }
    .media-body .type{
        font-size: 15px;
        color: #909399;
        font-weight: bold;
        margin: 0 0 10px 10px;
    }
    .media-body .name{
        margin-left: 10px;
        color: #62676d;
        line-height: 19px;
    }
    .media-text {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
    }
    .media-text span{
        color: #9fa6ad;
    }
</style>
